/**
 * @generated SignedSource<<502a268c52faac8a983c33a36590ea5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type persologElementQuestionFormDialog_PersologElementFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"persologElementQuestionForm_PersologElementFragment">;
  readonly " $fragmentType": "persologElementQuestionFormDialog_PersologElementFragment";
};
export type persologElementQuestionFormDialog_PersologElementFragment$key = {
  readonly " $data"?: persologElementQuestionFormDialog_PersologElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"persologElementQuestionFormDialog_PersologElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "persologElementQuestionFormDialog_PersologElementFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "persologElementQuestionForm_PersologElementFragment"
    }
  ],
  "type": "Persolog_PersologElement",
  "abstractKey": null
};

(node as any).hash = "6a15e2900a83e23a6827a37e1aa48584";

export default node;
